import Auth from '../auth/Auth';
import CustomerQcResult from "../models/CustomerQcResult";
import QcQuickNote from "../models/QcQuickNote";
import { WebClient } from './WebClient'

class ApiQc extends WebClient {
    async getQcItems(): Promise<CustomerQcResult[]> {
        const url = "/qc";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateQcItem(data: CustomerQcResult): Promise<CustomerQcResult> {
        return this.put("/qc", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
        }).catch(() => { return; });
    }

    async getQuickNotes(): Promise<QcQuickNote[]> {
        const url = "/qc/quicknote";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateQuickNote(data: QcQuickNote): Promise<QcQuickNote> {
        return this.put("/qc/quicknote", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async deleteQuickNote(qcQuickNoteId: number): Promise<boolean> {
        const url = `/qc/quicknote/${qcQuickNoteId}`;
        return this.delete(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async sendProfileLooksGood(qcId: number): Promise<CustomerQcResult> {
        const url = `/qc/looksgood/${qcId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async sendNoProfileBuilt(qcId: number): Promise<CustomerQcResult> {
        const url = `/qc/noprofile/${qcId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async sendQcMessage(completeQc: boolean, qcResult: CustomerQcResult): Promise<CustomerQcResult> {
        const url = `/qc/send/${completeQc}`;

        return this.post(url, qcResult, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiQc();
